import '../css/stylesheet.css';
import '../fonts/fontsheet.css';
import Window from "../Window"

function Home({ setWindows }){
    return (
        <Window windowName="Home" setWindows={setWindows}>
            <div style={{
                margin: "0.2em",
                padding: "0.1em",
                border: "4px solid #000000",
                boxSizing: "border-box",
                backgroundColor: "#FFFFFF", height: "99%"
            }}>
                <div style={{
                    margin: "0.1em",
                    padding: "0.5em",
                    border: "1px solid #000000",
                    boxSizing: "border-box",
                    overflowY: "auto", height: "99%"
                }}>
                    <h1>Who are you?</h1>
                    <p>
                        I'm a software engineer working on web technologies like Node, React, Javascript, and Rust. 
                        I have also worked with databases, namely Scylla and Postgres, and I have also worked with AWS. 
                        Beyond web development, I have also worked with Java, C++, C#, Python, and R.
                    </p>
                    <p>
                        I was educated at the University of Waterloo for applied mathematics from 2017 to 2022, 
                        and I learned a lot about programming and various other subjects. I also have one year
                        of experience working at Hive AI, a startup in San Francisco, and I have an additional
                        sixteen months of experience working at various startups in the Greater Toronto Area.
                    </p>
                    <h1>What is this website?</h1>
                    <p>I am a fan of the old-school Macintosh aesthetic, and this site is a small tribute to it.</p>
                </div>
            </div>
        </Window>
    );
}

export default Home;